import styled from 'styled-components';
import {grayLightest} from 'styles/constants';

export default styled.tr`
	${/*prettier-ignore*/ ({hover}) => hover ? `
		&:hover {
			td {
				background: ${grayLightest};
				cursor: default;
			}
		}
	` : ''};
	${/*prettier-ignore*/ ({status}) => status ? `
		& > :first-child {
			border-left: 4px solid ${status};
		}
	` : ''};
`;
